import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import "./design.css";
import Nav from "./nav";
import Footer from "./footer";
import Top from "./top";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const Design = () => {
  const { productId } = useParams();

  const [designs, setDesigns] = useState([]);
  const [showMoreDescId, setShowMoreDescId] = useState(null);

  useEffect(() => {
    document.title = "Vareprint | Design";
  }, []);

  useEffect(() => {
    axios
      .get(`${baseURL}/product/design1/${productId}`)
      .then(res => setDesigns(res.data.designs || []))
      .catch(err => console.error(err));
  }, [productId]);

  const toggleDescription = (id) => {
    setShowMoreDescId(showMoreDescId === id ? null : id);
  };

  return (
    <>
      <Nav />
      <Top />

      {/* Breadcrumb */}
      <div className="container" style={{ padding: "0px" }}>
        <ul className="filter_ul">
          <Link to="/"><li>Home</li></Link>
          <li>&nbsp;/&nbsp;</li>
          <li>Designs</li>
        </ul>
      </div>

      <div className="container design-container">
      <div className="row" style={{ display: 'flex' }}>
        {/* Personalized Section */}
        {/* <h4 style={{ marginTop: 14, marginBottom: -10 }}>Personalized</h4> */}
        <hr />

        <div className="col-sm-3 design_col" style={{background:'#e6e8e9'}}>
        <div className="design_filter">
          <h4 className='mt-2 underline'>Specailised Product</h4>
          <ul style={{listStyle: "none",
    fontSize: "15px",
    lineHeight: "32px",
    padding: "0px"}}>
            <li className='ul_border'>Acrylics Desktop</li>
            <li className='ul_border'>Bottles</li>
            <li className='ul_border'>Canvas Prints</li>
            <li className='ul_border'>Coasters</li>
            <li className='ul_border'>Fomex Posteres</li>
            <li className='ul_border'>Fridge Magnets</li>
            <li className='ul_border'>Gifts Envelopes</li>
            <li className='ul_border'>Labels</li>
            <li className='ul_border'>MousePads</li>
            <li className='ul_border'>Notebooks</li>
            <li className='ul_border'>Mugs</li>
            <li className='ul_border'>Pnes</li>
            <li className='ul_border'>T-shirts</li>
            <li className='ul_border'>Wirobooks</li>
            <li className='ul_border'>TableMats</li>
            <li className='ul_border'>Wooden Desktops</li>
          </ul>
          
          </div>
            </div>

       
          {designs.slice(0, 3).map(design => (
            <div key={design.did} className="col-sm-3 design_col">
              <div className="">
              <div className="design_div">
                <Link to={`/sub-design/${productId}`}>
                  <img
                    src={`${baseURL}/images/design/${design.images}`}
                    alt={design.pname}
                    className="design_image"
                  />
                  {/* <p className="sku_design">{design.sku_design}</p> */}
                  <p className="design_name"> {design.dname}</p>
                </Link>
                <p className="design_ds">{design.ds1}</p>
                <p className="price_s">&#8377; {design.total}</p>

                {/* More Description Toggle */}
              
                <p style={{ textAlign: 'left', lineHeight: '23px', fontSize: '13px', padding:'0 10px 15px 10px' }}>
                    This design is perfect for adding your personal touch. 
                    Customize colors, text, and style to match your preference. 
                    Ideal for gifts, events, or your own collection!
                    This design is perfect for adding your personal touch. 
                    Customize colors, text, and style to match your preference. 
                    Ideal for gifts, events, or your own collection!
                  </p>
                  </div>
              </div>
            </div>
          ))}
        </div>

      </div>

      <br />
      <Footer />
    </>
  );
};

export default Design;
